export default __webpack_public_path__ + "static/media/Explanation2.09416a76.JPEG";